module.exports = __webpack_public_path__ + "img/educacao.eb812bcd.svg";